import React from "react";

import { Image } from "react-bootstrap";
import { Tournament } from "@nestcoinco/hyper-api-gateway-api-client";
import { useTranslation } from "react-i18next";
import { useAtomValue } from "jotai";

import "./GatheringInfo.scss";
import { type IOpponentSummary } from "../../../jotai/atoms/tournament";
import { GameOutcome as Outcome } from "../../../utils/constants";
import ParticipantResult from "../../game-results-page/ParticipantResult/ParticipantResult";
import LoadingOverlay, {
  OverlayVariant,
} from "../../LoadingOverlay/LoadingOverlay";
import useAuth from "../../../hooks/useAuth";
import { userCustomAvatarAtom } from "../../../jotai/atoms/user";

interface GatheringInfoProps {
  duelOpponent: IOpponentSummary | null;
  tournamentDetails?: Tournament;
}

function GatheringInfo({
  duelOpponent,
  tournamentDetails,
}: GatheringInfoProps) {
  const { userProfile } = useAuth();
  const { t } = useTranslation("games");
  const userCustomAvatar = useAtomValue(userCustomAvatarAtom);

  return (
    <div className="d-flex flex-column h-100 pb-5">
      <div className="gathering-info">
        <p className="d-flex justify-content-center mb-2">
          <Image
            src={tournamentDetails?.game?.thumbnail}
            alt="game banner"
            width={34}
            className="game-thumbnail"
          />
        </p>

        <p className="game-title">{tournamentDetails?.game?.name}</p>
        <h1 className="main-heading slashed-zero">
          {t("game_results_page.please_wait")}
        </h1>
      </div>
      <div className="gathering-info participants-section d-flex align-items-center justify-content-evenly position-relative">
        <ParticipantResult
          outcome={Outcome.AWAITING_SCORE}
          isLoggedInUser
          username={userProfile?.username}
          avatar={userCustomAvatar || userProfile?.avatar?.url}
          isForLoader
        />
        <p className="versus">{t("versus")}</p>
        <ParticipantResult
          outcome={Outcome.AWAITING_SCORE}
          username={duelOpponent?.username}
          avatar={duelOpponent?.avatar}
          isForLoader
        />
      </div>
      <LoadingOverlay variant={OverlayVariant.GATHERING_INFO} />
    </div>
  );
}

export default GatheringInfo;
